<h2 mat-dialog-title class="mb-2" *ngIf="delivery.ccc">
    Update Delivery For Client : {{ delivery.ccc }}
</h2>
<h2 mat-dialog-title class="mb-2" *ngIf="delivery.group_name">
    Update Delivery For Group : {{ delivery.group_name }}
</h2>

<mat-dialog-content [formGroup]="editDeliveryForm" class="delivery-form-content scrollable-content">

    <!-- Meta Info -->
    <div class="meta-row">
        <div class="mb-3"><strong>Facility Name:</strong> {{ delivery?.facility_name }}</div>
        <div class="mb-3" *ngIf="delivery?.ccc"><strong>@if (orgId == environment.biNcdID){
            Patient ID:
        } @else {
            CCC:
        }</strong> {{ delivery?.ccc }}</div>
        <div class="mb-3" *ngIf="delivery?.group_name"><strong>Group Name:</strong> {{ delivery.group_name }}</div>
    </div>
    <div class="meta-row">
        <div class="mb-3" *ngIf="delivery?.drug_refill_date"><strong>Drug Refill Date (TCA):</strong> {{ delivery?.drug_refill_date }}</div>
        <div class="mb-3"><strong>Pref Delivery Date:</strong> {{ delivery?.prefered_delivery_date }}</div>
        <div class="mb-3" *ngIf="delivery?.package"><strong>Package:</strong> {{ delivery.package }}</div>

    </div>

    <!-- Common Form Fields -->
    <div class="meta-row">
        <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Delivery Date</mat-label>
            <input matInput [matDatepicker]="datePicker" formControlName="actual_delivery_date" />
            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-datepicker #datePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Delivery Time</mat-label>
            <mat-select formControlName="delivery_time">
                <mat-option value="Morning">Morning</mat-option>
                <mat-option value="Afternoon">Afternoon</mat-option>
                <mat-option value="Evening">Evening</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="meta-row">
        <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Delivery Coordinates</mat-label>
            <input matInput formControlName="actual_delivery_location" />
        </mat-form-field>

        <!-- Only show for individual -->
        <mat-form-field appearance="fill" class="w-100 mb-3" *ngIf="delivery.ccc">
            <mat-label>Delivery Outcome</mat-label>
            <mat-select formControlName="delivery_outcome">
                <mat-option *ngFor="let outcome of delivery_outcomes" [value]="outcome.value">
                    {{ outcome.label }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <mat-form-field appearance="fill" class="w-100 mb-3"
                    *ngIf="delivery.ccc && editDeliveryForm.get('delivery_outcome')?.value && editDeliveryForm.get('delivery_outcome')?.value !== 'successful'">
        <mat-label>Returned to Site</mat-label>
        <mat-select formControlName="medication_returned">
            <mat-option [value]="Yes">Yes</mat-option>
            <mat-option [value]="No">No</mat-option>
        </mat-select>
    </mat-form-field>

    <div class="meta-row">
        <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Name of Rider</mat-label>
            <input matInput formControlName="name_of_rider" (input)="onNameInput($event)" />
            <mat-error *ngIf="editDeliveryForm.get('name_of_rider')?.hasError('required')">
                Name of rider is required
            </mat-error>
            <mat-error *ngIf="editDeliveryForm.get('name_of_rider')?.hasError('containsNumbers')">
                Name cannot contain numbers
            </mat-error>
            <mat-error *ngIf="editDeliveryForm.get('name_of_rider')?.hasError('invalidCharacters')">
                Name can only contain letters, spaces, and apostrophes
            </mat-error>
            <mat-error *ngIf="editDeliveryForm.get('name_of_rider')?.hasError('repetitiveCharacters')">
                Name cannot have repetitive characters (e.g., aaa, bbb)
            </mat-error>
            <mat-error *ngIf="editDeliveryForm.get('name_of_rider')?.hasError('invalidPattern')">
                Please enter a valid name, not just apostrophes or spaces
            </mat-error>
            <mat-error *ngIf="editDeliveryForm.get('name_of_rider')?.hasError('tooShort')">
                Name must contain at least 2 letters
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Contact of Rider</mat-label>
            <span matPrefix style="display: flex; align-items: center; height: 100%;">+254&nbsp;</span>
            <input matInput formControlName="contact_of_rider" placeholder="123456789" maxlength="9" (input)="onContactInput($event)" />
            <mat-error *ngIf="editDeliveryForm.get('contact_of_rider')?.hasError('required')">
                Contact of rider is required
            </mat-error>
            <mat-error *ngIf="editDeliveryForm.get('contact_of_rider')?.hasError('invalidPhoneNumber')">
                Please enter a valid Kenyan phone number
            </mat-error>
        </mat-form-field>
    </div>

    <mat-form-field appearance="fill" class="w-100"
                    *ngIf="delivery.ccc && editDeliveryForm.get('delivery_outcome')?.value && editDeliveryForm.get('delivery_outcome')?.value !== 'successful'">
        <mat-label>Comments</mat-label>
        <textarea matInput rows="3" formControlName="comments"></textarea>
    </mat-form-field>

    <!-- Group Delivery Client FormArray -->
    <div *ngIf="delivery?.group_name && delivery?.ccc_list?.length > 0">
        <h3 class="mt-4">Client Delivery Outcomes ({{ delivery.ccc_list.length }})</h3>
        <div formArrayName="clients" class="ccc-table">

            <div *ngFor="let c of clients.controls; let i = index" [formGroupName]="i" class="ccc-row">
                <div class="meta-row align-items-start">
                    <div class="ccc-col mb-3" style="min-width: 160px;">
                        <strong>{{ c.get('ccc')?.value }}</strong>
                    </div>

                    <mat-form-field appearance="fill" class="w-100 mb-3">
                        <mat-label>Delivery Outcome*</mat-label>
                        <mat-select formControlName="delivery_outcome">
                            <mat-option *ngFor="let outcome of delivery_outcomes" [value]="outcome.value">
                                {{ outcome.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="w-100 mb-3"
                                    *ngIf="c.get('delivery_outcome')?.value && c.get('delivery_outcome')?.value !== 'successful'">
                        <mat-label>Returned to Site</mat-label>
                        <mat-select formControlName="medication_returned">
                            <mat-option [value]="Yes">Yes</mat-option>
                            <mat-option [value]="No">No</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="meta-row">
                    <mat-form-field
                            appearance="fill"
                            class="w-100 mb-3"
                            *ngIf="c.get('delivery_outcome')?.value && c.get('delivery_outcome')?.value !== 'successful'">
                        <mat-label>Comments</mat-label>
                        <input matInput formControlName="comments" />
                    </mat-form-field>
                </div>
            </div>

        </div>
    </div>

</mat-dialog-content>

<mat-dialog-actions align="end" class="mt-3">
    <button mat-raised-button color="warn" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="editDeliveryForm.invalid">Save</button>
</mat-dialog-actions>
